import { render, staticRenderFns } from "./CrmManagementDashboard.vue?vue&type=template&id=0091df02&scoped=true&"
import script from "./CrmManagementDashboard.vue?vue&type=script&lang=js&"
export * from "./CrmManagementDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CrmManagementDashboard.vue?vue&type=style&index=0&id=0091df02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091df02",
  null
  
)

export default component.exports